import { InjectionToken } from '@angular/core';
export const SS_URL = new InjectionToken<string>('ss-url');
